<div class="widget">
    <h1 class="section-title title">News Gallery</h1>
    <ul>
      <li *ngFor="let galleryArticle of galleryArticles"><a href="{{galleryArticle.articleImage}}" class="image-link"><img class="img-fluid" src="{{galleryArticle.articleImage}}" alt="{{galleryArticle.articleTitle}}" /></a></li>
    </ul>
  </div>
